import { get, patch, post } from '../../utils/http';

export const fetchOpenings = ({ accountId }) => get(`/accounts/${accountId}/ats/openings`);

export const fetchOpening = ({ accountId, openingId }) => get(`/accounts/${accountId}/ats/openings/${openingId}`);

export const createOpening = ({ accountId, opening }) => post(`/accounts/${accountId}/ats/openings`, opening);

export const updateOpening = ({ accountId, openingId, opening }) =>
  patch(`/accounts/${accountId}/ats/openings/${openingId}`, opening);
